<template>
  <div>
    <icon-view
      class="mr-2 mt-3 mb-4 rounded-circle icon-view-color-text"
      icon="fas fa-link color-orange mb-1"
      title="Información a Publicar"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      :gradient="true"
    />
    <div class="row">
      <div class="col-12 mb-4">
        <div class="row">
          <div class="col-12 col-md-3">
            <span class="data-title d-block mb-2">
              Fecha de Publicación:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="publicationDate"
              rules="required"
            >
              <custom-date-picker
                id="input-publicationDate"
                v-model="model.publishDate"
                :class-container="'w-100'"
                custom-error-msg="La fecha de publicación es requerido."
                :error="errors[0]"
                format="dd/MMM./yyyy"
                required
              />
            </validation-provider>
          </div>
          <div class="col-12 col-md-3">
            <span class="data-title d-block mb-2">
              Fecha de Finalización:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="dueDate"
              rules="required"
            >
              <custom-date-picker
                id="input-dueDate"
                v-model="model.dueDate"
                :class-container="'w-100'"
                custom-error-msg="La fecha de finalización es requerido."
                :error="errors[0]"
                required
                format="dd/MMM./yyyy"
              />
            </validation-provider>
          </div>
          <div class="col-12 col-md-3">
            <span class="data-title d-block mb-2">
              Área:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="area"
              rules="required"
            >
              <custom-drop-down
                v-model="model.area"
                id="area"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="El área de publicación es requerido."
                :error="errors[0]"
                :options="areaOptions"
              />
            </validation-provider>
          </div>
          <div class="col-12 col-md-3">
            <span class="data-title d-block mb-2">
              Tipo de Publicación:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="type"
              rules="required"
            >
              <custom-drop-down
                v-model="model.type"
                id="type"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="El tipo de publicación es requerido."
                :error="errors[0]"
                :options="typeOptions"
              />
            </validation-provider>
          </div>
        </div>
      </div>
      <div class="col-12 mb-4">
        <div class="row">
          <div class="col-12 col-md-3">
            <span class="data-title d-block mb-2">
              Categoría:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="category"
              rules="required"
            >
              <custom-drop-down
                v-model="model.category"
                id="category"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="La categoría es requerida."
                :error="errors[0]"
                :options="categoryOptions"
              />
            </validation-provider>
          </div>
          <div class="col-12 col-md-9">
            <span class="data-title d-block mb-2">
              Título:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="title"
              rules="required"
            >
              <custom-input
                v-model="model.title"
                id="title"
                maxlength="500"
                :error="errors[0]"
                custom-error-msg="El título es requerido."
              />
            </validation-provider>
          </div>
        </div>
      </div>
      <div class="col-12 mb-4">
        <div class="row">
          <div class="col-12">
            <span class="data-title d-block mb-2">
              Resumen:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="resumen"
              rules="required"
            >
              <custom-text-area
                id="input-resumen"
                v-model="model.resumen"
                class="textarea__extended"
                :count-classes="['float-right']"
                custom-error-msg="El resumen es requerido."
                :error="errors[0]"
                :maxlength="500"
                show-char-count
              />
            </validation-provider>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <span class="data-title d-block mb-2">
              Descripción / Contenido:
            </span>
            <ValidationProvider v-slot="{ errors }" rules="required">
              <vue-editor id="description-input" v-model="model.description" />
              <error
                v-if="errors[0]"
                message="La descripción/contenido es requerido."
                variant="no-border"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import IconView from "icon-view";
import CustomInput from "CustomInput";
import CustomTextArea from "CustomTextArea";
import CustomDatePicker from "custom-date-picker";
import CustomDropDown from "custom-drop-down";
import Error from "@/components/common/Error";
import { VueEditor } from "vue2-editor";

export default {
  name: "InformationToPublish",
  components: {
    IconView,
    CustomInput,
    CustomTextArea,
    CustomDatePicker,
    CustomDropDown,
    Error,
    VueEditor
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    areaOptions: {
      type: Array,
      default: () => []
    },
    typeOptions: {
      type: Array,
      default: () => []
    },
    categoryOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.textarea__extended ::v-deep {
  .position-relative {
    i {
      display: none;
    }
  }
}
</style>
